// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_7DaMxKL2AiqUR67F6eSMG","btn-prev-day":"JIuYXnTYdU-pqUH2vgSa8","btn-next-day":"_1YyPmlvU-yC7rnr32mrFkN","menu-full-site":"_2fkSK-MoyD2oeBkWV11n6"};